module.exports = __webpack_public_path__ + "fonts/ufonts.com_klavika-medium-opentype.c328903f.otf";